module.exports = __webpack_public_path__ + "img/04n.d1743056.png";